/**
 * 字段选择器组件
 */

import React from 'react';
import { Checkbox } from 'dingtalk-design-desktop';
import type { FieldInfo } from '../types';

interface FieldSelectorProps {
  fields: FieldInfo[];
  selectedFieldIds: string[];
  onSelectionChange: (selectedIds: string[]) => void;
  disabled?: boolean;
}

export const FieldSelector: React.FC<FieldSelectorProps> = ({
  fields,
  selectedFieldIds,
  onSelectionChange,
  disabled = false,
}) => {
  const handleCheckboxChange = (fieldId: string, checked: boolean) => {
    if (checked) {
      onSelectionChange([...selectedFieldIds, fieldId]);
    } else {
      onSelectionChange(selectedFieldIds.filter((id) => id !== fieldId));
    }
  };

  return (
    <div className="field-selector">
      <label className="selector-label">
        选择用于匹配的关键字段
      </label>
      <div className="field-list">
        {fields.map((field) => (
          <Checkbox
            key={field.id}
            checked={selectedFieldIds.includes(field.id)}
            onChange={(e) => handleCheckboxChange(field.id, e.target.checked)}
            disabled={disabled}
          >
            {field.name}
          </Checkbox>
        ))}
      </div>
      {/* <div className="field-selector-hint">
        匹配逻辑：根据字段值模糊匹配 biz_key 后缀
      </div> */}
    </div>
  );
};
